import { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { createIntersectionObserverManager } from '../../virtualization/IntersectionObserverManager';
import { useObserveElement } from '../../virtualization/useObserveElement';
import { jsx as _jsx } from "react/jsx-runtime";
const SentinelDiv = styled.div.withConfig({
  displayName: "InfiniteScrollSentinel__SentinelDiv",
  componentId: "sc-1dnza2w-0"
})(["height:1px;"]);
const InfiniteScrollSentinel = ({
  handleIntersectionChange
}) => {
  const [sentinelElementRef, setSentinelElementRef] = useState(null);
  const intersectionObserver = useMemo(() => createIntersectionObserverManager({
    threshold: 0
  }), []);
  const callback = useCallback(entry => {
    if (entry.isIntersecting) {
      handleIntersectionChange();
    }
  }, [handleIntersectionChange]);
  useObserveElement(intersectionObserver, sentinelElementRef, callback);
  return /*#__PURE__*/_jsx(SentinelDiv, {
    ref: setSentinelElementRef,
    "data-test-id": "infinite-scroll-sentinel"
  });
};
export default InfiniteScrollSentinel;